exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{font-family:Arial,sans-serif;line-height:1.6}.header{display:flex;justify-content:space-between;align-items:center}.header img{width:70px}.header .contact-info{text-align:center;font-size:10px}.title{font-size:12px;margin:10px 0}.subtitle,.title{text-align:center;font-weight:700}.subtitle{font-size:10px}table{width:100%}td,th{text-align:left;font-size:10px}th{font-weight:700}.description,.footer{font-size:10px;text-align:left}.description .description-heading{text-align:center;font-weight:700}.closing,.closing .under{text-align:center;font-size:10px}.closing .under{text-decoration:underline}.closing .under,.footer{font-weight:700;font-style:italic}.footer{font-size:10px;text-align:center;font-size:medium}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-41c8729e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/PolicyPrint.vue
// module id = 96
// module chunks = 0